import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ReRegistrationService {

  constructor(private firestore: AngularFirestore) { }

  getReRegistrations() {
    return this.firestore.collection('reRegistrations').snapshotChanges();
  }
}
